import React, {useState, useEffect} from 'react';
import {useSelector} from "react-redux";
import RevenueStatusSummary from "./RevenueStatusSummary";
import AdsenseTermsDialog from "./AdsenseTermsDialog";
import classnames from "classnames";

const ConnectIssueContent = ({onClickConnectButton}) => {
  const [showLayerPopup, setShowLayerPopup] = useState(false);

  return (
    <>
      <div className="wrap_cont wrap_cont_type2">
        <p className="desc_cont_type2">연동 상태의 재확인이 필요합니다. 연동하기 절차를 다시 진행해 주시기 바랍니다.</p>
      </div>
      <a className="btn_type5" onClick={onClickConnectButton}>연동하기</a>
      <div className="box_revenue_plat">
        <div>
          <dl className="count_revenue">
            <dt className="tit_revenue">노출수
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">클릭수
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">{'노출 RPM '}
              <div className={classnames('wrap_question', showLayerPopup ? 'open_question' : '')}
                   onMouseEnter={()=>setShowLayerPopup(true)}
                   onMouseLeave={()=>setShowLayerPopup(false)}
              >
                <span className="ico_blog ico_question">설명</span>
                <div className="layer_popup">
                  <div className="inner_popup inner_popup_type3">
                    <p className="desc_g">광고가 1,000회 노출됐을 때 얻을<br/> 수 있는 예상 수익을 말합니다.</p>
                  </div>
                </div>
              </div>
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">수익
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
        </div>
      </div>
    </>
  );
};

const Adsense = () => {
  const [view, setView] = useState('loading');
  const [showDetail, setShowDetail] = useState(false);
  const revenue = useSelector(state => state.revenue);

  const handleClickConnectButton = () => {
    setView('connecting');
  };

  const handleClickLoginButton = () => {
    const popupWidth = 620;
    const popupHeight = 700;
    const popupX = (window.screen.width / 2) - (popupWidth / 2);
    const popupY = (window.screen.height / 2) - (popupHeight / 2);
    window.open(revenue.adsenseInfo.url, "_blank", `width=${popupWidth},height=${popupHeight},left=${popupX},top=${popupY}`);
  };

  const handleClickDetailButton = () => {
    setShowDetail(true);
  };

  useEffect(() => {
    if (revenue.adsenseInfo) {
      if (revenue.adsenseInfo.accountCode === 'SUCCESS') {
        if (revenue.adsenseInfo.mediaStatusCode === 'PASS') {
          setView('connected')
        } else {
          setView('ongoing')
        }
      } else if (revenue.adsenseInfo.accountCode === 'NOT_FOUND_TOKEN') {
        setView('intro');
      } else {
        setView('issue')
      }
    }
  }, [revenue.adsenseInfo]);

  return (
    <div className="box_blog box_blog_type2">
      <div className="wrap_logo">
        <img src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/googleadsense.png"
             alt="Google AdSense" className="company_logo" width="140"/>
      </div>
      {view === 'intro' &&
      <>
        <div className="wrap_cont">
          <strong className="screen_out">특징</strong>
          <ul className="list_cont list_cont_type2">
            <li><span className="ico_blog ico_check_type3"/><span
              className="txt_g">ads.txt 파일 문제 해결</span></li>
            <li><span className="ico_blog ico_check_type3"/><span
              className="txt_g">최고의 가격을 제시한 광고 게재</span></li>
            <li><span className="ico_blog ico_check_type3"/><span
              className="txt_g">코드 하나로 설정되는 자동 광고</span></li>
          </ul>
        </div>

        <a className="btn_type5" onClick={handleClickConnectButton}>연동하기</a>
      </>
      }
      {view === 'connecting' &&
      <>
        <div className="wrap_cont wrap_cont_type2">
          <strong className="screen_out">연동하기 프로세스</strong>
          <ol className="list_revenue_tab">
            <li className="on">연동 안내</li>
            <li>AdSense 로그인</li>
            <li>연동 완료</li>
          </ol>
        </div>
        <div className="box_revenue_plat">
          {showDetail &&
          <AdsenseTermsDialog close={() => setShowDetail(false)}/>
          }
          <strong className="screen_out">연동방법</strong>
          <ul className="list_cont_type1">
            <li>
              <span className="num_g">1.</span>
              <span className="txt_g">{'애드센스를 연동하는 것은 AFP에 참여하는 것을 의미합니다. '}</span>
              <a className="txt_g" onClick={handleClickDetailButton}>자세히</a>
            </li>
            <li>
              <span className="num_g">2.</span>
              <span className="txt_g">애드센스를 사용하는 구글 계정으로 로그인 해주세요.</span>
            </li>
            <li>
              <span className="num_g">3.</span>
              <span className="txt_g">심사 및 진행 상황은 구글 홈페이지에서 확인해 주시기 바랍니다.</span>
            </li>
          </ul>
        </div>
        <a className="btn_type6" onClick={handleClickLoginButton}><span className="ico_blog ico_google_type1"/>Google
          로그인</a>
      </>
      }
      {view === 'issue' &&
      <ConnectIssueContent
        onClickConnectButton={handleClickConnectButton}
      />
      }
      {view === 'connected' &&
      <RevenueStatusSummary vendor="adsense"/>
      }
    </div>

  )
};

export default Adsense;